export class DefinitionEtat {
  id: string;
  categorieCle: number;
  section: string;
  statut: string;
  statutCle: number;
  sectionCle: number;

  constructor() {}

}

export class CheckList {
  id: string;
  categorieCle: number;
  libelle: string;
  code: string;
  type: string;
  cle: number;

  constructor() {}

}

export class Categorie {
  id: string;
  km: boolean;
  typeCode: string;
  hr: boolean;
  code: string;
  intitule: string;
  cle: number;

  constructor() {}

}



// WEBPACK FOOTER //
// ./src/app/model/categorie.ts